<template>
    <div class="pages" :class="{ 'is-h5': isH5 }">
        <!-- 顶部信息 -->
        <shortcut-bar class="shortcut-bar page-header" />
        <div class="page-header-placeholder"></div>

        <!-- 搜索 -->
        <div ref="searchBar" class="home-center-search">
            <div class="search-box">
                <div class="flex align-center search-box-input-wrap">
                    <img src="../../../../static/images/icon/icon11.png" alt="">
                    <!-- <div class="text-bf text-14">请输入您想搜索的内容</div> -->
                    <input type="text" :placeholder="$t('请输入您想搜索的内容')" v-model="keyword" @keyup.enter="onSearch">
                </div>
                <div class="search-box-btn" @click="onSearch">{{ $t('搜索') }}</div>
            </div>
        </div>

        <!-- 商品 -->
        <div ref="searchContent" class="box">
            <!-- 商品标题 -->
            <div class="box-tit">{{ $t('搜索商品') }}</div>
            <!-- 商品筛选 -->
            <!-- {'current-image': (image.index == currentImgIndex)} -->
            <div class="box-screen text-14">
                <div class="flex align-center screen-box" :class="order == 'comprehensive' ? 'screen-box1' : ''"
                    @click="onSortord(1)">
                    <span>{{ $t('综合') }}</span>
                </div>
                <div class="flex align-center screen-box" :class="order == 'price' ? 'screen-box1' : ''"
                    @click="onSortord(2)">
                    <span>{{ $t('价格') }}</span>
                    <div v-if="order == 'price'">
                        <img src="../../../../static/images/icon/icon13.png" alt="" v-if="orderway == ''">
                        <img src="../../../../static/images/icon/icon33.png" alt="" v-if="orderway == 'desc'">
                        <img src="../../../../static/images/icon/icon32.png" alt="" v-if="orderway == 'asc'">
                    </div>
                    <img src="../../../../static/images/icon/icon13.png" alt="" v-else>
                </div>
                <div class="flex align-center screen-box" :class="order == 'time' ? 'screen-box1' : ''"
                    @click="onSortord(3)">
                    <span>{{ $t('时间') }}</span>
                    <div v-if="order == 'time'">
                        <img src="../../../../static/images/icon/icon13.png" alt="" v-if="orderway == ''">
                        <img src="../../../../static/images/icon/icon33.png" alt="" v-if="orderway == 'desc'">
                        <img src="../../../../static/images/icon/icon32.png" alt="" v-if="orderway == 'asc'">
                    </div>
                    <img src="../../../../static/images/icon/icon13.png" alt="" v-else>
                </div>
                <div class="screen-num">
                    <input type="number" placeholder="0" v-model="min_price" @blur="onIput('min')"
                        @keyup.enter="onIput('min')">
                    <div class="screen-num-line"></div>
                    <input type="number" placeholder="99999+" v-model="max_price" @blur="onIput('max')"
                        @keyup.enter="onIput('max')">
                </div>
            </div>
            <!-- 商品列表 -->
            <!-- <div class="box-list">
                <div class="list-box" v-for="( item, index ) in  goodFreshList " :key="index">
                    <img :src="item.cover" alt="" class="box-img">
                    <div class="box-bottom">
                        <div class="box-bottom-tit line2">{{ item.name }}</div>
                        <div class="box-bottom-box">
                            <div class="box-bottom-box-l">
                                ￥<span class="text-20">{{ item.price }}</span>
                            </div>
                            <div class="box-bottom-box-r" @click="gotoDetail(item)">
                                <div class="box-bottom-box-rl">
                                    <img src="../../../../static/images/icon/icon12.png" alt="">
                                </div>
                                <div class="box-bottom-box-rr">{{ $t('购买') }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="list-box-tag" v-if="item.product_type">{{ $t('虚拟商品') }}</div>
                </div>
            </div> -->
            <div class="list">
                <div ref="searchProductCard" class="list-box" v-for="(item, index) in goodFreshList" :key="index" @click="gotoDetail(item)">
                    <div class="img-container">
                        <img :src="item.cover" alt="" class="box-img">
                    </div>
                    <div class="box-bottom">
                        <div class="box-bottom-tit line2">{{ item.name }}</div>
                        <div class="box-bottom-box">
                            <div class="box-bottom-box-l">
                                ￥<span class="text-20">{{ item.price }}</span>
                            </div>
                            <div class="box-bottom-box-r">
                                <div class="box-bottom-box-rr">
                                    <div class="box-bottom-box-rrl" style="border-right: 1px solid #000000;"
                                        @click.stop="onCollect(item.id, index)">
                                        <img src="../../../../static/images/icon/icon35.png" alt="" v-if="item.is_collect">
                                        <img src="../../../../static/images/icon/icon18.png" alt="" v-else>
                                    </div>
                                    <div class="box-bottom-box-rrl">
                                        <img src="../../../../static/images/icon/icon07.png" alt="">
                                    </div>
                                    <div class="box-bottom-box-rrr">{{ $t('购买') }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="list-box-tag" v-if="item.product_type">{{ $t('虚拟商品') }}</div>
                </div>
            </div>
        </div>

        <!-- 右侧悬浮框 -->
        <div class="pc-float">
            <rightSuspension />
        </div>
        <!-- 左侧悬浮框 -->
        <div class="pc-float">
            <leftSuspension boxItme="1" />
        </div>

        <footer-bar></footer-bar>
    </div>
</template>

<script>
import ShortcutBar from '@/components/ShortcutBar';
import rightSuspension from "@/components/rightSuspension.vue";
import leftSuspension from "@/components/leftSuspension.vue";
import { commodityList, commodityCollect } from '@/api/user';
import footerBar from '@/components/footerBar';

export default {
    name: 'searchOk',
    components: {
        'footer-bar': footerBar,
        'shortcut-bar': ShortcutBar,
        rightSuspension,
        leftSuspension,
    },
    data() {
        return {
            keyword: '',//搜索内容
            goodFreshList: [],//商品列表
            order: 'comprehensive',//排序方式
            orderway: '',//排序方式
            min_price: '',//价格区间搜索，最低价
            max_price: '',//价格区间最高价
            isH5: typeof window !== 'undefined' && window.innerWidth < 768,
            // 搜索页面入场动画实例，用于搜索刷新和组件销毁时释放动画资源
            searchEntranceAnimation: null,
        }
    },
    mounted() {
        this.updateIsH5();
        window.addEventListener('resize', this.updateIsH5);
        this.keyword = this.$route.params.keyword;
        this.onSearch()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateIsH5);
        if (this.searchEntranceAnimation) {
            this.searchEntranceAnimation.progress(1).kill();
        }
    },
    methods: {
        /** 播放搜索页面及商品列表的入场动效 */
        playSearchEntranceAnimation() {
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                return;
            }
            if (this.searchEntranceAnimation) {
                this.searchEntranceAnimation.progress(1).kill();
            }
            const targets = [this.$refs.searchBar, this.$refs.searchContent]
                .concat(this.$refs.searchProductCard || [])
                .filter(Boolean);
            if (!targets.length) {
                return;
            }
            this.searchEntranceAnimation = this.$gsap.fromTo(targets, {
                y: this.isH5 ? 10 : 16,
                opacity: 0,
            }, {
                y: 0,
                opacity: 1,
                duration: 0.42,
                stagger: 0.06,
                ease: 'power2.out',
                onComplete: () => {
                    this.$gsap.set(targets, { clearProps: 'opacity,transform' });
                },
            });
        },
        updateIsH5() {
            this.isH5 = window.innerWidth < 768;
        },
        /**收藏 */
        onCollect(id, i) {
            commodityCollect({ id: id }).then(res => {
                if (res.code == 1) {
                    if (this.goodFreshList[i].is_collect == 1) {
                        this.$message.success(this.$t('已取消'));
                        this.goodFreshList[i].is_collect = 0
                    } else {
                        this.$message.success('已收藏');
                        this.goodFreshList[i].is_collect = 1
                    }
                }
            })
        },
        /**商品详情 */
        gotoDetail(e) {
            this.$router.push({ name: 'ProductDetails', params: { id: e.id } })
        },
        /**价格输入 */
        onIput(type) {
            if (type == 'min' && this.min_price != '') {
                this.min_price = Number(this.min_price);
            }
            if (type == 'max' && this.max_price != '') {
                this.max_price = Number(this.max_price);
            }

            // 检查最小值是否大于最大值
            if (this.min_price != '' && this.max_price != '' && this.min_price > this.max_price) {
                if (type == 'min') {
                    this.min_price = ''
                    this.$message.warning(this.$t('最小值不能大于最大值'));
                } else {
                    this.max_price = ''
                    this.$message.warning(this.$t('最大值不能小于最小值'));
                }
            }
            if (this.min_price && this.max_price) {
                this.onSearch()
            }
        },
        /**切换排序 */
        onSortord(i) {
            if (i == 1) {
                this.orderway = ''
            } else {
                if (this.orderway == 'desc') {
                    this.orderway = 'asc'
                } else {
                    this.orderway = 'desc'
                }
            }

            if (i == 1) {
                this.order = 'comprehensive'
            } else if (i == 2) {
                this.order = 'price'
            } else if (i == 3) {
                this.order = 'time'
            }
            this.onSearch()
        },
        /**搜索 */
        onSearch() {
            let data = {
                keyword: this.keyword,
                orderby: this.order,
            }
            if (this.orderway) {
                data.orderway = this.orderway
            }
            if (this.min_price && this.max_price) {
                data.min_price = this.min_price;
                data.max_price = this.max_price;
            }
            commodityList(data).then(res => {
                this.goodFreshList = res.data.data
                this.$nextTick(() => {
                    this.playSearchEntranceAnimation();
                });
            })
        }
    },
};
</script>

<style scoped lang="scss">
.page-header {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}

.page-header-placeholder {
    height: 56px;
}

/**搜索框 */
.home-center-search {
    padding: 32px 320px;
    margin: 24px 0 48px;

    .search-box {
        width: 100%;
        height: 46px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #F8F8F8;
        box-sizing: border-box;
        border-radius: 30px;

        .search-box-input-wrap {
            width: calc(100% - 100px);
        }

        img {
            width: 18px;
            height: 18px;
            margin-right: 14px;
            margin-left: 22px;
        }

        .search-box-btn {
            height: 100%;
            background: #61AC85;
            font-size: 14px;
            color: #FFFFFF;
            padding: 0 26px;
            line-height: 46px;
            border-radius: 30px;
            cursor: pointer;
        }

        input {
            background: #F8F8F8;
            width: 90%;
        }
    }
}

/**商品 */
.box {
    padding: 0 var(--page-gutter) 40px;
    min-height: 70vh;

    /**商品标题 */
    .box-tit {
        font-size: 32px;
        color: #333333;
        margin-bottom: 24px;
    }

    /**商品筛选 */
    .box-screen {
        display: flex;

        .screen-box {
            padding: 5px 11px;
            border: 1px solid #EEEEEE;
            margin-right: 32px;
            border-radius: 4px;
            cursor: pointer;

            img {
                width: 14px;
                height: 14px;
                display: block;
                margin-left: 8px;
            }
        }

        .screen-box1 {
            border: 1px solid #000000;
            color: #000000;
        }

        .screen-num {
            display: flex;
            align-items: center;

            input {
                width: 88px;
                height: 32px;
                border: 1px solid #EEEEEE;
                border-radius: 4px;
                padding: 0 12px;
            }

            .screen-num-line {
                width: 40px;
                height: 1px;
                background: #EEEEEE;
                margin: 0 12px;
            }
        }
    }

    /**商品列表 */
    .list {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;

        @media (min-width: 768px) {
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 20px;
        }

        @media (min-width: 1280px) {
            grid-template-columns: repeat(4, minmax(0, 1fr));
            gap: 24px;
        }

        .list-box {
            width: 100%;
            margin-right: 0;
            margin-top: 12px;
            position: relative;
            transition: all 0.3s ease;
            border-radius: 8px;
            padding: 8px;
            box-sizing: border-box;
            cursor: pointer;
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);

            @media (min-width: 768px) {
                margin-top: 32px;
                padding: 12px;
            }

            &:hover {
                @media (hover: hover) {
                    transform: translateY(-5px);

                    .img-container {
                        overflow: hidden;
                        border-radius: 8px;
                    }
                }
            }

            .img-container {
                width: 100%;
                // 与首页商品卡片统一使用 3:4 图片容器比例。
                aspect-ratio: 3 / 4;
                height: auto;
                border-radius: 8px;
                overflow: hidden;
                background: #F5F5F5;
            }

            .box-img {
                width: 100%;
                height: 100%;
                border-radius: 8px;
                // 保持商品图片完整显示，适配不同宽高比例的图片。
                object-fit: contain;
                transition: transform 0.3s ease;
            }

            .box-bottom {
                margin-top: 10px;

                @media (min-width: 768px) {
                    margin-top: 16px;
                }

                .box-bottom-tit {
                    width: 100%;
                    line-height: 18px;
                    height: 36px;
                    font-size: 13px;

                    @media (min-width: 768px) {
                        line-height: 20px;
                        height: 40px;
                        font-size: inherit;
                    }
                }

                .box-bottom-box {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 8px;
                    flex-wrap: wrap;
                    gap: 6px;

                    .box-bottom-box-l {
                        color: #85674B;
                        font-size: 13px;
                    }

                    .box-bottom-box-r {
                        display: flex;
                        align-items: center;

                        .box-bottom-box-rl {
                            margin-right: 12px;

                            img {
                                width: 24px;
                                height: 24px;
                            }
                        }

                        .box-bottom-box-rr {
                            background: #FFFFFF;
                            border: 1px solid #000000;
                            display: flex;
                            border-radius: 4px;

                            .box-bottom-box-rrl {
                                padding: 6px 8px;

                                @media (min-width: 768px) {
                                    padding: 8px 16px;
                                }

                                img {
                                    width: 16px;
                                    height: 16px;
                                    display: block;

                                    @media (min-width: 768px) {
                                        width: 18px;
                                        height: 18px;
                                    }
                                }
                            }

                            .box-bottom-box-rrr {
                                padding: 6px 10px;
                                font-size: 12px;
                                background: #000000;
                                color: #FFFFFF;
                                cursor: pointer;

                                @media (min-width: 768px) {
                                    padding: 8px 16px;
                                    font-size: 14px;
                                }
                            }
                        }
                    }
                }
            }

            .list-box-tag {
                position: absolute;
                top: 12px;
                left: 12px;
                padding: 2px 8px;
                font-size: 12px;
                color: #000000;
                border: 1px solid #000000;
                border-radius: 6px;
                background-color: rgba(255, 255, 255, 0.5);
            }
        }

        .list-box:nth-child(4n) {
            margin-right: 0;
        }
    }
}

/* PC 端搜索内容区与首页保持一致，固定使用 1280px 页面栅格。 */
@media (min-width: 768px) {
    .home-center-search,
    .box {
        width: 1280px;
        margin-left: auto;
        margin-right: auto;
        box-sizing: border-box;
    }

    .home-center-search {
        padding: 32px 0;
        margin-top: 24px;
        margin-bottom: 48px;
    }

    .box {
        padding: 0 0 40px;
    }
}

/** H5 适配：仅追加媒体查询，PC 样式零改动 */
@media (max-width: 767px) {
    .pages.is-h5 {
        overflow-x: hidden;
        width: 100%;
        background: #f5f6f8;
    }

    .page-header {
        padding-top: env(safe-area-inset-top, 0px);
    }

    .page-header-placeholder {
        height: calc(56px + env(safe-area-inset-top, 0px));
    }

    .pc-float {
        display: none;
    }

    /**搜索框 H5 */
    .home-center-search {
        padding: 12px 12px 0;
        margin: 0 0 12px;

        .search-box {
            height: 40px;
            border-radius: 24px;

            .search-box-input-wrap {
                width: calc(100% - 72px);
                min-width: 0;
            }

            img {
                width: 16px;
                height: 16px;
                margin-right: 8px;
                margin-left: 14px;
            }

            .search-box-btn {
                padding: 0 16px;
                line-height: 40px;
                font-size: 13px;
                flex-shrink: 0;
            }

            input {
                width: 100%;
                font-size: 14px;
            }
        }
    }

    /**商品 H5 */
    .box {
        padding: 0 12px 24px;
        box-sizing: border-box;

        .box-tit {
            font-size: 18px;
            margin-bottom: 12px;
            padding: 0 4px;
        }

        .box-screen {
            flex-wrap: wrap;
            gap: 8px;

            .screen-box {
                margin-right: 0;
                margin-bottom: 0;
                padding: 6px 10px;
                font-size: 13px;

                img {
                    width: 12px;
                    height: 12px;
                    margin-left: 6px;
                }
            }

            .screen-num {
                width: 100%;
                margin-top: 4px;

                input {
                    flex: 1;
                    width: auto;
                    min-width: 0;
                    height: 32px;
                    font-size: 13px;
                }

                .screen-num-line {
                    width: 24px;
                    margin: 0 8px;
                    flex-shrink: 0;
                }
            }
        }

        .list {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 12px;
            padding-top: 12px;

            .list-box {
                width: 100%;
                margin-right: 0;
                margin-top: 12px;
                padding: 8px;
                box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);

                &:hover {
                    transform: none;

                    .img-container .box-img {
                        transform: none;
                    }
                }

                .img-container {
                    height: auto;
                    // H5 与首页保持相同 3:4 容器，并让图片按比例铺满。
                    aspect-ratio: 3 / 4;
                }

                .box-img {
                    display: block;
                    object-fit: cover !important;
                    object-position: center;
                }

                .box-bottom {
                    margin-top: 10px;

                    .box-bottom-tit {
                        line-height: 18px;
                        height: 36px;
                        font-size: 13px;
                    }

                    .box-bottom-box {
                        margin-top: 8px;
                        flex-wrap: wrap;
                        gap: 6px;

                        .box-bottom-box-l {
                            font-size: 12px;
                        }

                        .box-bottom-box-r {
                            .box-bottom-box-rr {
                                .box-bottom-box-rrl {
                                    padding: 6px 8px;

                                    img {
                                        width: 16px;
                                        height: 16px;
                                    }
                                }

                                .box-bottom-box-rrr {
                                    padding: 6px 10px;
                                    font-size: 12px;
                                }
                            }
                        }
                    }
                }

                .list-box-tag {
                    top: 12px;
                    left: 12px;
                    padding: 2px 8px;
                    font-size: 12px;
                }
            }

            .list-box:nth-child(4n) {
                margin-right: 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/home/components/searchOk.vue